import React from 'react';
import WordleGame from './components/WordleGame';
import './App.css';

function App() {
  return (
    <div className="App">
      <WordleGame />
    </div>
  );
}

export default App;
